var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQTutorDefault = function SvgQTutorDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q_tutor_default_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E4E7F4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFF",
    fillRule: "evenodd",
    d: "M24 30a8 8 0 0 0 8-7.999A8 8 0 0 0 24 14a8 8 0 0 0-8 8.001A8 8 0 0 0 24 30",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFF",
    d: "M13.072 35.712A8 8 0 0 1 19.826 32h8.348a8 8 0 0 1 6.754 3.712l4.78 7.53C41.569 46.17 39.465 50 35.995 50H12.006c-3.47 0-5.575-3.829-3.715-6.758z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "q_tutor_default_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    rx: 24
  })))));
};
export { SvgQTutorDefault as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzcwNTVfODQ2NjkpIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNFNEU3RjQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNCAzMEMyOC40MTg1IDMwIDMyIDI2LjQxOSAzMiAyMi4wMDExQzMyIDE3LjU4MSAyOC40MTg1IDE0IDI0IDE0QzE5LjU4MTUgMTQgMTYgMTcuNTgxIDE2IDIyLjAwMTFDMTYgMjYuNDE5IDE5LjU4MTUgMzAgMjQgMzBaIiBmaWxsPSIjRkJGQkZGIi8+CjxwYXRoIGQ9Ik0xMy4wNzE4IDM1LjcxMTlDMTQuNTM5NCAzMy40MDA0IDE3LjA4NzQgMzIgMTkuODI1NSAzMkgyOC4xNzQ1QzMwLjkxMjYgMzIgMzMuNDYwNiAzMy40MDA0IDM0LjkyODIgMzUuNzExOUwzOS43MDg5IDQzLjI0MTZDNDEuNTY4OSA0Ni4xNzEgMzkuNDY0NCA1MCAzNS45OTQ0IDUwSDEyLjAwNTZDOC41MzU2NSA1MCA2LjQzMTE0IDQ2LjE3MSA4LjI5MTA3IDQzLjI0MTZMMTMuMDcxOCAzNS43MTE5WiIgZmlsbD0iI0ZCRkJGRiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzcwNTVfODQ2NjkiPgo8cmVjdCB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHJ4PSIyNCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";